import React from "react";
import { Box, Card, Typography } from "@mui/material";
import AccountCircleRounded from "@mui/icons-material/AccountCircleRounded";
import { useZoomPlayerStyles } from "./style";
import { formatTime } from "./utils";
import { APP_COLORS } from "../../enums";
import { Clock } from "@phosphor-icons/react";

type TranscriptLine = { start: number; end: number; text: string; speaker: string };

type TranscriptPanelProps = {
  transcript: TranscriptLine[];
  currentTime: number;
  seekingToTime: number | null;
  onSeek: (line: TranscriptLine) => void;
  transcriptRef: React.RefObject<HTMLDivElement>;
  onUserInteract?: () => void;
};

export const TranscriptPanel: React.FC<TranscriptPanelProps> = ({
  transcript,
  currentTime,
  seekingToTime,
  onSeek,
  transcriptRef,
  onUserInteract,
}) => {
  const classes = useZoomPlayerStyles();

  const handleScroll = (e: React.UIEvent) => {
    e.stopPropagation();
    onUserInteract?.();
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.stopPropagation();
    onUserInteract?.();
  };

  return (
    <Box
      className={classes.transcriptScroll}
      ref={transcriptRef}
      onWheel={handleWheel}
      onTouchStart={onUserInteract}
      onScroll={handleScroll}
    >
      {transcript.map((line, index) => {
        const isActive = currentTime >= line.start && currentTime <= line.end;
        const isSeeking = seekingToTime !== null && seekingToTime === line.start;
        const itemClass = `${classes.transcriptItem} ${isActive ? classes.transcriptItemActive : ""} ${isSeeking ? classes.transcriptItemSeeking : ""
          }`;
        const textClass = isActive ? classes.transcriptTextActive : classes.transcriptText;

        return (
          <Box p={1} bgcolor={APP_COLORS.greyLight}>
            <Card sx={{ p: 0 }}>
              <Box key={`${line.start}-${index}`} className={itemClass} onClick={() => onSeek(line)}>
                <Box className={classes.rowCenterGap8Mb4} sx={{ justifyContent: "space-between" }}>
                  <Box className={classes.speakerRow}>
                    <Clock size={22} />
                    <Typography variant="medium-mono-medium">
                      {line.speaker}
                    </Typography>
                  </Box>
                  <Typography className={classes.timeCaption} fontWeight={500} variant="caption" display="flex" alignItems="center" gap={.3}>
                    <Clock size={18} />
                    {formatTime(line.start)}
                  </Typography>
                </Box>
                <Typography variant="body-ibmPlexMono" color={APP_COLORS.greyDark}>
                  {line.text.replace(/^[^:]+:\s*/, "")}
                </Typography>
              </Box>
            </Card>
          </Box>
        );
      })}
    </Box>
  );
};


